export default __webpack_public_path__ + "static/media/gallery08.bb26d2cb.jpg";